import type { Role } from "@/context/BranchContext";
import type { PermissionSet } from "@/config/permissions";

export interface MockEmployee {
  name: string;
  phone: string;
  role: Role;
  branchName: string;
  storeName: string;
  /** الصلاحيات المحفوظة لدى صاحب المحل — يسترجعها النظام عند تسجيل الدخول */
  permissions: PermissionSet;
}

/**
 * سجل الموظفين المختصر لأغراض العرض.
 * الدور (المسمى الوظيفي) والصلاحيات يُحدّدهما صاحب المحل من لوحة الموظفين.
 * الصلاحيات هنا أمثلة محفوظة فقط — وليست مرتبطة تلقائيًا بالمسمى.
 */
export const mockBranchEmployees: Record<Role, MockEmployee> = {
  cashier: {
    name: "عبدالله الحربي",
    phone: "0551234567",
    role: "cashier",
    branchName: "فرع العليا",
    storeName: "مطعم الذوق الرفيع",
    permissions: {
      receiveOrders: true,
      updateOrderStatus: true,
      pos: true,
      productAvailability: false,
      editQuantities: false,
      customerRatings: false,
      workingHours: false,
      pickupPolicy: false,
      emergencyClosure: false,
      reports: false,
    },
  },
  shift_supervisor: {
    name: "محمد الشمري",
    phone: "0551111222",
    role: "shift_supervisor",
    branchName: "فرع العليا",
    storeName: "مطعم الذوق الرفيع",
    permissions: {
      receiveOrders: true,
      updateOrderStatus: true,
      pos: true,
      productAvailability: true,
      editQuantities: true,
      customerRatings: true,
      workingHours: false,
      pickupPolicy: false,
      emergencyClosure: false,
      reports: false,
    },
  },
  operations: {
    name: "فهد العنزي",
    phone: "0552222333",
    role: "operations",
    branchName: "فرع العليا",
    storeName: "مطعم الذوق الرفيع",
    permissions: {
      receiveOrders: true,
      updateOrderStatus: true,
      pos: true,
      productAvailability: true,
      editQuantities: true,
      customerRatings: true,
      workingHours: false,
      pickupPolicy: false,
      emergencyClosure: false,
      reports: false,
    },
  },
  branch_manager: {
    name: "سلطان القحطاني",
    phone: "0559876543",
    role: "branch_manager",
    branchName: "فرع العليا",
    storeName: "مطعم الذوق الرفيع",
    permissions: {
      receiveOrders: true,
      updateOrderStatus: true,
      pos: true,
      productAvailability: true,
      editQuantities: true,
      customerRatings: true,
      workingHours: true,
      pickupPolicy: true,
      emergencyClosure: true,
      reports: false,
    },
  },
  owner: {
    name: "خالد الدوسري",
    phone: "0553333444",
    role: "owner",
    branchName: "فرع العليا",
    storeName: "مطعم الذوق الرفيع",
    permissions: {
      receiveOrders: true,
      updateOrderStatus: true,
      pos: true,
      productAvailability: true,
      editQuantities: true,
      customerRatings: true,
      workingHours: true,
      pickupPolicy: true,
      emergencyClosure: true,
      reports: true,
    },
  },
};

/**
 * في النظام الفعلي يتعرّف النظام على الموظف من رقم الجوال المسجّل لدى صاحب المحل،
 * ثم يسترجع مسمّاه الوظيفي وصلاحياته المحفوظة.
 */
export const phonePresetMap: Record<string, Role> = {
  "0559876543": "branch_manager",
  "0553333444": "owner",
  "0552222333": "operations",
  "0551111222": "shift_supervisor",
  "0551234567": "cashier",
};

/** مسمى افتراضي لأي رقم غير مُسجّل في العرض التجريبي */
export const defaultRole: Role = "cashier";

export const mockBranchInfo = {
  branchName: "فرع العليا",
  storeName: "مطعم الذوق الرفيع",
  status: "open" as "open" | "closed" | "emergency_closed" | "disabled",
  address: "الرياض — حي العليا، طريق الملك فهد، مخرج 9",
  phone: "0112345678",
  taxNumber: "300123456700003",
  commercialName: "مطعم الذوق الرفيع",
  unreadNotifications: 3,
};